import React from 'react';
import DonationForm from '../components/DonationForm';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const DonatePage = () => {
   const [isContactModalOpen, setIsContactModalOpen] = React.useState(false);
      const openContactModal = () => setIsContactModalOpen(true);
    const closeContactModal = () => setIsContactModalOpen(false);
  return (
    <div className="donate-page min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      {/* En-tête de la page */}
      <Header openContactModal={openContactModal} />
         {/* Modal de contact */}
      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={closeContactModal} 
      />
      <div className="bg-gradient-to-r from-fsf-primary to-fsf-secondary py-16">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Soutenir FSF
          </h1>
          <p className="text-xl text-white/90 max-w-3xl mx-auto text-justify">
            Votre générosité nous aide à poursuivre notre mission d'accompagnement des couples mariés 
            et de rayonnement de la foi catholique au Bénin.
          </p>
        </div>
      </div>
      
      {/* Section Donation */}
      <section id="don" className="py-8">
        <DonationForm />
      </section>
      <Footer />
    </div>
  );
};

export default DonatePage;